import { TYPE_ENTITY } from './entities'

export enum ProfitEntity {
  PUBLIC_LIMITED = 'A1',
  SPECIAL_CORPORATION = 'A2',
  CIVIL_SOCIETY = 'A3',
  GENERAL_PARTNERSHIP = 'A4',
  ENTREPRENEURSHIP_SOCIETY = 'A5',
  INVESTMENT_COMPANY = 'A6',
  LIMITED_PARTNERSHIP = 'A7',
  SIMPLE_LIMITED_PARTNERSHIP = 'A8',
  SHARES_LIMITED_PARTNERSHIP = 'A9',
  FOREIGN_CORPORATION = 'A10',
  OTHER = 'A11'
}

export const PROFIT_ENTITY = {
  PUBLIC_LIMITED: 'A1',
  SPECIAL_CORPORATION: 'A2',
  CIVIL_SOCIETY: 'A3',
  GENERAL_PARTNERSHIP: 'A4',
  ENTREPRENEURSHIP_SOCIETY: 'A5',
  INVESTMENT_COMPANY: 'A6',
  LIMITED_PARTNERSHIP: 'A7',
  SIMPLE_LIMITED_PARTNERSHIP: 'A8',
  SHARES_LIMITED_PARTNERSHIP: 'A9',
  FOREIGN_CORPORATION: 'A10',
  OTHER: 'A11'
}

export const NAME_PROFIT_ENTITY = {
  A1: 'SOCIEDAD ANÓNIMA',
  A2: 'SOCIEDAD ANÓNIMA ESPECIAL',
  A3: 'SOCIEDAD CIVIL',
  A4: 'SOCIEDAD COLECTIVA',
  A5: 'SOCIEDAD DE EMPRENDIMIENTO',
  A6: 'SOCIEDAD DE INVERSIÓN',
  A7: 'SOCIEDAD LIMITADA',
  A8: 'SOCIEDAD EN COMANDITA SIMPLE',
  A9: 'SOCIEDAD EN COMANDITA POR ACCIONES',
  A10: 'SOCIEDAD MERCANTIL EXTRANJERA',
  A11: 'OTRA'
}

export const CATALOG_PROFIT_ENTITY = [
  {
    value: PROFIT_ENTITY.PUBLIC_LIMITED,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A1
  },
  {
    value: PROFIT_ENTITY.SPECIAL_CORPORATION,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A2
  },
  {
    value: PROFIT_ENTITY.CIVIL_SOCIETY,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A3
  },
  {
    value: PROFIT_ENTITY.GENERAL_PARTNERSHIP,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A4
  },
  {
    value: PROFIT_ENTITY.ENTREPRENEURSHIP_SOCIETY,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A5
  },
  {
    value: PROFIT_ENTITY.INVESTMENT_COMPANY,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A6
  },
  {
    value: PROFIT_ENTITY.LIMITED_PARTNERSHIP,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A7
  },
  {
    value: PROFIT_ENTITY.SIMPLE_LIMITED_PARTNERSHIP,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A8
  },
  {
    value: PROFIT_ENTITY.SHARES_LIMITED_PARTNERSHIP,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A9
  },
  {
    value: PROFIT_ENTITY.FOREIGN_CORPORATION,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A10
  },
  {
    value: PROFIT_ENTITY.OTHER,
    type: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_PROFIT_ENTITY.A11
  }
]
